export enum Constants {
    PATTERN = "^[\\w-\\+]+(\\.[\\w]+)*@[\\w-]+(\\.[\\w]+)*(\\.[a-zA-Z.-]{2,})$",
    EMAIL_PATTERN = "^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$",
    URL_PATTERN ="^(ftp:\/\/|http:\/\/|https:\/\/|www\.)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$",
    LANGUAGE = "eng",
    ERRORMSG= "Gigaton Service Error",
    UPDATE= "update",
    DELETE= "delete",
    CREATE= "create",
    SPA= "spa",
    TEST= "test",
    LABEL= "label",
    CHI= "chi",
    TABCHANGE= "tabChange",
    TAB= "tab",
    HOME= "home",
    CDP= "cdp",
    PAGECDP= "pageCdpOverview",
    GSF= "gsf",
    PAGEGSF= "pageGsfOverview",
    OVERVIEW= "overview",
    MODIFIED= "modified"
}
